import { fetcher } from '@commenda/utils';

export async function getSenderViewUrl(
  envelopeId: string,
  returnUrl: string
): Promise<Response> {
  const params = new URLSearchParams({ returnUrl });
  return fetcher(
    `e-signature/envelopes/${envelopeId}/sender-view?${params.toString()}`,
    { method: 'GET' }
  );
}
